module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-7-sm-7005c37e70b57445a27b3acd849d0d59.png";